import SnapshotComparison from '../components/SnapshotComparison/SnapshotComparison';

const SNAPSHOT_COMPARISON_ROUTES = [
  {
    id: 'snapshotComparison',
    path: '/snapshot-comparison',
    exact: true,
    component: SnapshotComparison
  }
];

export default SNAPSHOT_COMPARISON_ROUTES;
